"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMessageFromUser = isMessageFromUser;
exports.isOLXImageURL = isOLXImageURL;
exports.isSystemMessage = isSystemMessage;
exports.lastMessageFromUser = lastMessageFromUser;
exports.parseMessages = void 0;
exports.splitCustomType = splitCustomType;
exports.validateEmoji = validateEmoji;
var _systemUser = require("../helpers/systemUser");
var _timeUtil = require("./timeUtil");
var _excluded = ["originalTimestamp", "tip", "notificationData"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function isMessageFromUser(_ref) {
  var customType = _ref.customType;
  var _splitCustomType = splitCustomType(customType),
    type = _splitCustomType.type;
  return ['normal', 'sticker', 'image'].includes(customType) || (0, _systemUser.isSystemUser)(type);
}
function isSystemMessage(_ref2) {
  var customType = _ref2.customType;
  var _splitCustomType2 = splitCustomType(customType),
    type = _splitCustomType2.type;
  return (0, _systemUser.isSystemUser)(type);
}
function lastMessageFromUser(messages) {
  var userMessages = messages.filter(function (msg) {
    return isMessageFromUser(msg);
  });
  return userMessages.length > 0 ? userMessages[userMessages.length - 1] : null;
}
function isOLXImageURL(message) {
  return /^(https?:\/\/)?chat-images.olx.com.br\/image\/([0-9-_]+)\/([0-9a-f-]+)\.(gif|jpg|jpeg|png|bmp|webp)$/i.test(message) || /^(https?:\/\/)?auth-img.olx.com.br\/images\/auth\/[0-9a-f]{2}\/[0-9a-f-]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\.(jpg)$/i.test(message);
}
function splitCustomType(customType) {
  var _ref3 = typeof customType === 'string' ? customType.split(/\/(.+)/) : [customType],
    _ref4 = _slicedToArray(_ref3, 2),
    type = _ref4[0],
    subType = _ref4[1];
  return {
    type: type,
    subType: subType
  };
}
function validateEmoji(message) {
  return (message === null || message === void 0 ? void 0 : message.length) > 0 && !/(?:[\0-\xA8\xAA-\xAD\xAF-\u203B\u203D-\u2048\u204A-\u2121\u2123-\u2138\u213A-\u2193\u219A-\u21A8\u21AB-\u2319\u231C-\u2327\u2329-\u2387\u2389-\u23CE\u23D0-\u23E8\u23F4-\u23F7\u23FB-\u24C1\u24C3-\u25A9\u25AC-\u25B5\u25B7-\u25BF\u25C1-\u25FA\u25FF\u2606\u2613\u2686-\u268F\u2706\u2707\u2713\u2715\u2717-\u271C\u271E-\u2720\u2722-\u2727\u2729-\u2732\u2735-\u2743\u2745\u2746\u2748-\u274B\u274D\u274F-\u2752\u2756\u2758-\u2762\u2768-\u2794\u2798-\u27A0\u27A2-\u27AF\u27B1-\u27BE\u27C0-\u2933\u2936-\u2B04\u2B08-\u2B1A\u2B1D-\u2B4F\u2B51-\u2B54\u2B56-\u302F\u3031-\u303C\u303E-\u3296\u3298\u329A-\uD7FF\uE000-\uFFFF]|[\uD800-\uD83B\uD840-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD72-\uDD7D\uDD80-\uDD8D\uDD8F\uDD90\uDD9B-\uDDAC\uDDE6-\uDE00\uDE10-\uDE19\uDE1B-\uDE2E\uDE30\uDE31\uDE3B\uDE40-\uDE48\uDFFB-\uDFFF]|\uD83D[\uDD3E-\uDD45\uDE50-\uDE7F\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD3B\uDD46\uDF00-\uDFFF]|\uD83F[\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/.test(message);
}
var parseMessages = exports.parseMessages = function parseMessages() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var serverTimestamp = arguments.length > 1 ? arguments[1] : undefined;
  return messages.map(function (message) {
    var originalTimestamp = message.originalTimestamp,
      tip = message.tip,
      notificationData = message.notificationData,
      otherProps = _objectWithoutProperties(message, _excluded);
    var notificationDataParsed = notificationData && typeof notificationData == 'string' ? JSON.parse(notificationData) : {};
    var timestampDelta = (0, _timeUtil.calcTimestampDelta)(serverTimestamp);
    var timestamp = (0, _timeUtil.applyTimestampDeltaInMicroseconds)(originalTimestamp, timestampDelta);
    return _objectSpread(_objectSpread({}, otherProps), {}, {
      originalTimestamp: originalTimestamp,
      timestamp: timestamp,
      notificationData: notificationDataParsed,
      tip: tip || undefined
    });
  });
};